import { PERFORMANCE_VERSION } from '@src/slide/infrastructure/module/dependent/performance/constant';
import { PERFORMANCE_ID, reportPerformance } from '@src/slide/infrastructure/module/dependent/performance/common';

interface IHtmlPerformance {
    FetchStart: number,
    DnsTime: number,
    TcpLinkTime: number,
    RedirectCount: number,
    HtmlTTFB: number,
    HtmlDuration: number,
    PerformanceVersion: string,
    PerformanceID: string,
}

/**
 * HTML performance 相关信息 以及上报tdw.
 */
function htmlMonitor() {
    const performanceHTML: IHtmlPerformance = {
        FetchStart: -1,
        DnsTime: -1,
        TcpLinkTime: -1,
        RedirectCount: -1,
        HtmlTTFB: -1,
        HtmlDuration: -1,
        PerformanceVersion: PERFORMANCE_VERSION,
        PerformanceID: PERFORMANCE_ID,
    };

    if (!global.performance) return;

    const { navigationStart } = global.performance.timing;

    performanceHTML.FetchStart = Math.floor(global.performance.timing.fetchStart - navigationStart);
    performanceHTML.DnsTime = Math.floor(global.performance.timing.domainLookupEnd
        - global.performance.timing.domainLookupStart);
    performanceHTML.TcpLinkTime = Math.floor(global.performance.timing.connectEnd
        - global.performance.timing.connectStart);
    performanceHTML.RedirectCount = Math.floor(global.performance.navigation.redirectCount);
    performanceHTML.HtmlTTFB = Math.floor(global.performance.timing.responseStart
        - global.performance.timing.requestStart);
    performanceHTML.HtmlDuration = Math.floor(global.performance.timing.responseEnd
        - global.performance.timing.responseStart);

    reportPerformance('HTML', performanceHTML);

    const html = {
        info: {
            redirectStart: -1,
            redirectEnd: -1,
            fetchStart: -1,
            domainLookupStart: -1,
            domainLookupEnd: -1,
            connectStart: -1,
            connectEnd: -1,
            requestStart: -1,
            responseStart: -1,
            responseEnd: -1,
        },
        TTFB: -1,
    };
    html.info.redirectStart = global.performance.timing.redirectStart === 0
        ? 0 : Math.floor(global.performance.timing.redirectStart - navigationStart);
    html.info.redirectEnd = global.performance.timing.redirectEnd === 0
        ? 0 : Math.floor(global.performance.timing.redirectEnd - navigationStart);
    html.info.fetchStart = Math.floor(global.performance.timing.fetchStart - navigationStart);
    html.info.domainLookupStart = Math.floor(global.performance.timing.domainLookupStart - navigationStart);
    html.info.domainLookupEnd = Math.floor(global.performance.timing.domainLookupEnd - navigationStart);
    html.info.connectStart = Math.floor(global.performance.timing.connectStart - navigationStart);
    html.info.connectEnd = Math.floor(global.performance.timing.connectEnd - navigationStart);
    html.info.requestStart = Math.floor(global.performance.timing.requestStart - navigationStart);
    html.info.responseStart = Math.floor(global.performance.timing.responseStart - navigationStart);
    html.info.responseEnd = Math.floor(global.performance.timing.responseEnd - navigationStart);
    html['开始下载时间'] = Math.floor(html.info.requestStart);
    html.TTFB = html.info.responseStart - html.info.requestStart;
    html['下载耗时'] = html.info.responseEnd - html.info.responseStart;
}


if (!global.isInWorker) htmlMonitor();
